import { Outlet, createFileRoute } from "@tanstack/react-router";

function Feed() {
  return <Outlet />;
}

export const Route = createFileRoute("/_authenticated/app/feed")({
  component: Feed,
});
